import axios from "axios";
import i18n from "../../i18n";

// Shared axios instance so the httpOnly auth cookie set by the backend at
// login is sent (and any Set-Cookie from the backend honored) on every
// request, without needing to touch each individual call site.
//
// The X-Requested-With header is a CSRF defense the backend requires on
// every state-changing request: a plain cross-site <form> post can't set a
// custom header, and any request that does set one forces a CORS preflight
// first, which the backend's origin allow-list then gets to reject. Only
// our own JS (this axios instance) can set it.
const apiClient = axios.create({
  withCredentials: true,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

// Attach the current UI language on every request so backend error/success
// messages (req.t(...)) come back in the same language the user has
// selected, instead of the server's default. Read at request time (not
// baked into the instance's default headers) since the user can switch
// languages mid-session via the language switcher.
apiClient.interceptors.request.use((config) => {
  config.headers["X-Lang"] = i18n.language || "fr";
  // Axios will not set the multipart boundary if Content-Type is already
  // present. Strip it so FormData uploads actually reach multer.
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    if (typeof config.headers?.delete === "function") {
      config.headers.delete("Content-Type");
      config.headers.delete("content-type");
    } else if (config.headers) {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    }
  }
  return config;
});

export default apiClient;
